import { SEARCH_MIN_CHARS } from '../constants';
import { useSpotlightCapabilities } from '../hooks/useSpotlightCapabilities';

type Params = {
	searchTerm: string;
	isLoadingResults: boolean;
	isDropdownSearchDisabled: boolean;
};

// Recent searches show below SEARCH_MIN_CHARS regardless of selected options. When the dropdown does
// not search (keyword-only NLS), result sections stay hidden but recent searches still show.
export function useResultsVisibility({
	searchTerm,
	isLoadingResults,
	isDropdownSearchDisabled,
}: Params) {
	const { canShowRecentSearches } = useSpotlightCapabilities();

	const isBelowMinChars = searchTerm.length < SEARCH_MIN_CHARS;
	const showResultSkeletons = isLoadingResults && !isDropdownSearchDisabled && !isBelowMinChars;

	const showRecentSearches = canShowRecentSearches && isBelowMinChars;
	const showResults = !isBelowMinChars && !showResultSkeletons && !isDropdownSearchDisabled;

	return { showRecentSearches, showResults, showResultSkeletons };
}
